module.exports = __webpack_public_path__ + "img/44.7784ff82.gif";